import { UserGroupIcon } from '@heroiconsv2/react/24/outline'
import { LABEL, PANEL, ROW_START, SectionCard } from './BookingSection'

const BookingPartnerDetailsCard = ({ bookingData, t }) => {
  if (!bookingData?.partner) return null

  return (
    <SectionCard icon={UserGroupIcon} title={t('booking.sections.partnerDetails')}>
      <div>
        <div className={PANEL}>
          <div className={ROW_START}>
            <div className={LABEL}>{t('booking.labels.name')}</div>
            <div className="text-sm sm:text-base text-slate-800 sm:text-right break-words">{bookingData?.partner?.name || '-'}</div>
          </div>

          {bookingData?.partner?.email && (
            <div className={ROW_START}>
              <div className={LABEL}>{t('booking.labels.email')}</div>
              <div className="text-sm sm:text-base text-slate-800 sm:text-right break-all">{bookingData.partner.email}</div>
            </div>
          )}

          {bookingData?.partner?.phone && (
            <div className={ROW_START}>
              <div className={LABEL}>{t('booking.labels.phone')}</div>
              <div className="text-sm sm:text-base text-slate-800 sm:text-right">{bookingData.partner.phone}</div>
            </div>
          )}

          {/* {bookingData?.partner?.websiteUrl && (
                        <div className={ROW_START}>
                          <div className={LABEL}>{t('partner.profile.form.websiteUrl')}</div>
                          <div className="text-sm sm:text-base text-slate-800 sm:text-right break-all">
                            <a href={bookingData.partner.websiteUrl} target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">
                              {bookingData.partner.websiteUrl}
                              <ArrowTopRightOnSquareIcon className="!w-4 sm:!w-5 h-4 inline-block ml-1" />
                            </a>
                          </div>
                        </div>
                      )} */}
        </div>
      </div>
    </SectionCard>
  )
}

export default BookingPartnerDetailsCard
